import axios from "axios";
import {
  hasKpcAutoLoginCredentials,
  refreshKpcSession,
} from "./kpcAuth";

// TODO 로젠 API
export const LogenInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOGEN_API_URL}/AndyLogen`,
});

LogenInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 로젠 API
export const LogenTestInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TEST_API_URL}/AndyLogen`,
});

LogenTestInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 롯데 API
export const LotteInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOTTE_API_URL}/AndyLotte`,
});

LotteInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한진 API
export const HanjinInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANJIN_API_URL}/AndyHanjin`,
});

HanjinInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한덱스 API
export const HandexInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANDEX_API_URL}/AndyHandex`,
});

HandexInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// KPC 고객 웹은 서버가 발급한 HttpOnly 세션 쿠키로 인증한다.
export const KpcInstance = axios.create({
  baseURL: process.env.REACT_APP_KPC_API_URL,
  withCredentials: true,
});

const KPC_SESSION_EXPIRED_KEY = "kpc-session-expired";

// /watcher/sign은 로그인과 비밀번호 변경이 함께 사용하므로 요청 api까지 확인한다.
const getKpcRequestApi = (config) => {
  try {
    const requestData =
      typeof config?.data === "string" ? JSON.parse(config.data) : config?.data;
    return requestData?.api || "";
  } catch {
    return "";
  }
};

// 중복 오류 응답이 와도 로그인 화면 이동은 한 번만 예약한다.
const scheduleKpcSessionExpiry = () => {
  const hasScheduledSessionExpiry =
    window.sessionStorage.getItem(KPC_SESSION_EXPIRED_KEY) !== null;

  if (hasScheduledSessionExpiry) {
    return;
  }

  // 로그인 성공 전까지 표식을 유지해 뒤늦은 실패 응답의 반복 이동을 차단한다.
  window.sessionStorage.setItem(KPC_SESSION_EXPIRED_KEY, "pending");

  if (window.location.pathname !== "/") {
    window.location.replace("/");
  }
};

KpcInstance.interceptors.response.use(
  (response) => {
    const requestUrl = response.config?.url || "";
    const isSuccessfulLogin =
      requestUrl.includes("/watcher/sign") &&
      getKpcRequestApi(response.config) === "signIn" &&
      (response.data?.result === "00" || response.data?.result === "77");

    // 만료 잠금은 KPC 재로그인이 실제로 성공한 경우에만 해제한다.
    if (isSuccessfulLogin) {
      window.sessionStorage.removeItem(KPC_SESSION_EXPIRED_KEY);
    }

    return response.data;
  },
  async (error) => {
    const requestUrl = error.config?.url || "";
    const isLoginRequest =
      requestUrl.includes("/watcher/sign") &&
      getKpcRequestApi(error.config) === "signIn";
    const isLogoutRequest = requestUrl.includes("/watcher/logout");
    const status = error.response?.status;
    // CORS 정책으로 인증 실패 응답 본문을 읽지 못하면 Axios는 ERR_NETWORK로 전달한다.
    const isCorsBlockedAuthError =
      !error.response && error.code === "ERR_NETWORK";
    const isKpcAuthError =
      status === 401 || status === 403 || isCorsBlockedAuthError;
    const originalRequest = error.config;

    // 자동로그인을 선택한 KPC 사용자의 401은 새 세션 발급 후 원래 요청을 한 번만 재시도한다.
    // 여러 요청이 동시에 실패해도 refreshKpcSession 내부에서 하나의 Promise를 공유한다.
    if (
      status === 401 &&
      !isLoginRequest &&
      !isLogoutRequest &&
      !originalRequest?._kpcRetry &&
      hasKpcAutoLoginCredentials()
    ) {
      originalRequest._kpcRetry = true;
      const authenticatedUser = await refreshKpcSession();

      if (authenticatedUser) {
        window.sessionStorage.removeItem(KPC_SESSION_EXPIRED_KEY);
        return KpcInstance(originalRequest);
      }
    }

    // 로그인 실패는 비밀번호 오류일 수 있으므로 강제 로그아웃 대상에서 제외한다.
    // 자동로그인 실패, 403, CORS 차단은 기존 방식대로 로그인 화면으로 이동한다.
    if (isKpcAuthError && !isLoginRequest && !isLogoutRequest) {
      scheduleKpcSessionExpiry();
    }

    return Promise.reject(error);
  },
);

// TODO 동영상 전용 API
export const videoInstance = axios.create({
  baseURL: `${process.env.REACT_APP_VIDEO_API_URL}`,
});

videoInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);
